import CampaignIcon from '@mui/icons-material/Campaign'
import DashboardIcon from '@mui/icons-material/Dashboard'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import { routeFrontOfficeCommonUser } from '@/lib/routes/front/common/routeFrontOfficeCommonUser'
import { routeFrontOfficeContracts } from '@/lib/routes/front/common/routeFrontOfficeContracts'
import { routeFrontOfficeInvoices } from '@/lib/routes/front/common/routeFrontOfficeInvoices'
import { routeFrontOfficeMyCampaigns } from '@/lib/routes/front/common/routeFrontOfficeMyCampaigns'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

export const getFrontOfficeStoreBagPharmacien = [
  {
    // HORS menu : l'action « Commandes PLV a passer » ouvre desormais la dialog « Ma PLV,
    // comment ca marche ? » SUR PLACE (StoreBagActivationProvider) — le tableau de bord
    // PLV n'apportait que cet auto-open. La route reste servie (home d'entite, deep-links,
    // repli des fronts qui ne connaissent pas encore la dialog).
    route: 'Dashboard',
    text: 'Tableau de bord',
    t: 'routes.frontoffice.storeBag.dashboard',
    icon: DashboardIcon,
    href: '/frontoffice/store-bag/home',
    home: true,
    position: 10,
  },
  {
    // HORS menu : fusionnee dans « Mes campagnes » transverse (Ma pharmacie). La page
    // reste servie pour les deep-links existants.
    route: 'campaignsStoreBag',
    text: 'Mes campagnes',
    t: 'routes.frontoffice.storeBag.campaigns',
    icon: CampaignIcon,
    href: '/frontoffice/store-bag/campaigns',
    position: 20,
  },
  ...routeFrontOfficeMyCampaigns,
  ...routeFrontOfficeContracts,
  ...routeFrontOfficeInvoices,
  // Entrée « Abonnements et Factures achats » (scopée Store via ?entityData) retirée :
  // les abonnements sont désormais consolidés (toutes entités) sur la page principale
  // /frontoffice/group/billing/sales-invoices (menu « Abonnements »).
  {
    route: 'GuidesDocumentations',
    text: 'Guides & Documentations',
    t: 'routes.frontoffice.storeBag.documentation',
    icon: MenuBookIcon,
    href: '/frontoffice/group/documentation',
    menuHeader: true,
    position: 210,
  },

  ...routeFrontOfficeCommonUser,
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDISTOREBAG],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_PLV_PHARMACIEN],
}))
